import type { Collection } from "@/partner/entities/contents";
import { CollectionContentSortType } from "@/types/graphql/partner.generated";
import type { CollectionFormValues } from "./types";

export const mapCollectionToFormValues = (
  collection: Collection
): CollectionFormValues => ({
  title: collection.title || "",
  description: collection.description ?? null,
  tagIds: collection.tags?.map((tag) => tag.id) ?? [],
  previewId: collection.preview?.id ?? null,
  verticalPreviewId: collection.verticalPreview?.id ?? null,
  publishAt: collection.publishAt ?? null,
  countryAccessId: collection.countryAccess?.id ?? null,
  hideInGeneralLists: collection.hideInGeneralLists ?? false,
  hideChildrenContentFromLists:
    collection.hideChildrenContentFromLists ?? false,
  collectionIds: collection.collectionIds ?? [],
  productIds: collection.productIds ?? [],
  collectionTypeId: collection.collectionTypeId ?? null,
  collectionContentSort:
    collection.collectionContentSort ?? CollectionContentSortType.LatestType,
});
